import { render } from "./PinkCat.svg?vue&type=template&id=6e99dc68"
const script = {}
script.render = render

export default script